<template>
  <div class="flex flex-col items-center justify-center">
    <graphic-base width="100" height="100" view-box="0 0 126 126">
      <circle-email />
    </graphic-base>
    <div
      class="text-center w-4/5 lg:w-9/12 my-10"
      :style="[firstLoginCustomParamsFields.styles.form.textColor]"
    >
      <h1 class="text-zt-lg mb-3 font-bold">
        {{ $t('message.loginComponent.firstLogin.enterMail') }}
      </h1>
      <p>{{ $t('message.loginComponent.firstLogin.enterMailMessage') }}</p>
    </div>
    <div class="w-full" v-if="showAlertError">
      <zt-alert
        :text="alertMessageError"
        color="danger"
        :duration="MAX_DURATION_ALERT_ERROR"
        @afterClosed="showAlertError = false"
      />
    </div>
    <ValidationObserver v-slot="{ invalid }">
      <div class="mb-10 relative">
        <ValidationProvider
          rules="required|email|min:2"
          v-slot="{ errors, invalid }"
        >
          <zt-input
            outlined
            name="email"
            :label="$t('message.loginComponent.languagesVuetify.inputMail')"
            :style="[firstLoginCustomParamsFields.styles.form.inputs.bgColor]"
            :color="colorOutlineEmail(invalid)"
            v-model="userEmail"
            data-vs-input="auth-firstlogin-input-email"
          />
          <span class="text-zt-danger absolute left-0" v-show="errors[0]"
            >{{ $t('message.loginComponent.validations.emailRules.validMail') }}
          </span>
          <span
            class="text-zt-md mt-4 block"
            :style="[firstLoginCustomParamsFields.styles.form.textColor]"
          >
            {{ $t('message.loginComponent.firstLogin.rememberValidMail') }}
          </span>
        </ValidationProvider>
      </div>
      <div class="mb-4 w-full">
        <zt-button
          class="w-full opacity-100"
          :style="[bgButtonColor(invalid)]"
          :disabled="invalid || disabledButtonSend"
          @click="updateEmailFirstLogin"
          data-vs-button="auth-firstlogin-button-update"
        >
          <span v-if="!isLoadingFirstLoginEmail">
            {{ $t('message.loginComponent.firstLogin.send') }}
          </span>
          <vue-loading
            v-if="isLoadingFirstLoginEmail"
            background-color="rgba(0,0,0,0.0)"
            :active="isLoadingFirstLoginEmail"
            color="#4F41A3"
            :width="30"
            :height="30"
            :is-full-page="false"
          />
        </zt-button>
      </div>
    </ValidationObserver>
    <div class="w-full flex justify-between">
      <div class="mb-4 hover:underline">
        <a
            @click="updateEmailFirstLogin"
            :style="[firstLoginCustomParamsFields.styles.form.textColor]"
            data-vs-link="auth-firstlogin-link-update-email"
        >{{ $t('message.loginComponent.firstLogin.notEmail') }}</a
        >
      </div>
      <div class="mb-4">
        <a
          @click="activeModalFirstLogin"
          class="flex items-center justify-center"
          :style="[firstLoginCustomParamsFields.styles.form.textColor]"
          data-vs-link="auth-firstlogin-link-active-modal"
        >
          <p>{{ $t('message.loginComponent.login.help') }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import CircleEmail from '@/components/commons/Illustrations/graphicSVG/circleEmail'
import Users from '@/apiClient/Users'
import { mapGetters } from 'vuex'
import { mutation } from '@/modules/Auth/hooks/activeFirstLoginModal'

export default {
  name: 'ztAuthFirstLoginEmailRequired',
  components: { CircleEmail, GraphicBase },
  props: {
    firstLoginCustomParamsFields: {
      type: Object,
      default: () => {}
    },
    userPassword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoadingFirstLoginEmail: false,
      disabledButtonSend: false,
      userEmail: '',
      showAlertError: false,
      alertMessageError: '',
      MAX_DURATION_ALERT_ERROR: 4
    }
  },
  computed: {
    ...mapGetters({
      getLoginCustomParams: 'auth/getLoginCustomParams',
      getUser: 'getUser'
    }),
    bgButtonColor() {
      return invalid =>
        invalid
          ? { backgroundColor: '#e2e2e2' }
          : this.firstLoginCustomParamsFields.styles.form.buttons.bgColor
    },
    colorOutlineEmail() {
      return invalid =>
        invalid
          ? 'danger'
          : this.firstLoginCustomParamsFields.styles.form.inputs.outlineColor
    }
  },
  methods: {
    async updateEmailFirstLogin() {
      this.isLoadingFirstLoginEmail = true
      this.disabledButtonSend = true
      try {
        await this.user.changeMail(this.userPassword, this.userEmail)
        this.$emit('changeEmailSuccess')
        await this.$store.dispatch('clearState')
        this.isLoadingFirstLoginEmail = false
        this.disabledButtonSend = false
      } catch (error) {
        this.isLoadingFirstLoginEmail = false
        this.disabledButtonSend = false
        this.showAlertError = true
        typeof error === 'string'
          ? (this.alertMessageError = this.$t(
              `message.errorReference.${error}`
            ))
          : (this.alertMessageError = this.$t(
              `message.errorReference.${error.response.data.code}`
            ))
      }
    },
    activeModalFirstLogin() {
      mutation.setActiveModalFirstLogin(true)
    }
  },
  created() {
    this.user = new Users()
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-button {
  height: 3.25rem;
}
</style>
